export enum MandateLimit {
  Unlimited = "Unlimited",
  Ten = "10",
  OneHundred = 100,
  TwoHundred = 200,
  //FiveHundred = 500,
  SevenHundredAndFifty = 750,
}
